import { useToken } from "@chakra-ui/react";
import type { FC } from "react";
import type { IconBaseProps } from "react-icons";

export const UsaFlag: FC<IconBaseProps> = ({
  size: externalSize = "1em",
  color: externalColor = "currentColor",
  ...props
}) => {
  const [size] = useToken("sizes", [externalSize]);
  const [color] = useToken("colors", [externalColor]);

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.001 5.22266H22.0019V8.61133M12.001 5.22266V8.61133M12.001 5.22266H2V12M12.001 8.61133V12M12.001 8.61133H22.0019M12.001 12H2M12.001 12H22.0019M2 12V15.3887M2 15.3887V18.7773H22.0019V15.3887M2 15.3887H22.0019M22.0019 15.3887V12M22.0019 12V8.61133"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};
